import { getSongAtIndex, canSkip, setFirstPlay, checkFavoriteContent, checkFavoriteInsidePlayer } from '../../actions/musica/player-shared-action-creators';
import { showNotification } from '../../actions/notification';
import { goToNextSong } from '../../actions/musica/player-controls-user';
import { playFullMedia} from '../../actions/playmedia';
import Translator from './../../requests/apa/Translator';
import MusicUtils from '../../actions/musica/music-actions';

import * as EVENTS from '../../actions/musica/playermusica';
import * as CONSTANTS from '../../constants/musica/player';
import * as userType from '../../constants/musica/users-type';

export const shuffler = require('shuffle-array');

export const getRandomOrderSongs = songs => shuffler(songs, { copy: true });

export const getRandomIndex = (length) => {
  const min = 0;
  const max = length;
  if (max === 1) {
    return 0;
  }
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const addSongsToPlayerPlaylist = (songs,
                                         index = 0,
                                         replaceInsteadOfAppend = true,
                                         atEnd = true,
                                         shuffle = false,
                                         play = false,
                                         onPlayButton = false
) => (dispatch, getState) => {
  const state = getState();
  const statePlayer = state.playermusica;

  let currentContent = { ...statePlayer.currentContent };

  if (replaceInsteadOfAppend) {
    if(songs[index] !== undefined){
      currentContent = {
        ...songs[index],
        index,
      };
    }
  }

  dispatch({
    type: EVENTS.ADD_SONGS_TO_PLAYER_PLAYLIST,
    songs,
    replaceInsteadOfAppend,
    atEnd,
    shuffle,
    currentContent
  });

  return Promise.resolve();
};

export const addSongsToPlayerPlaylistStartAt = (index,
                                                songs,
                                                replaceInsteadOfAppend = true,
                                                atEnd = true,
                                                shuffle = false,
                                                play = false,
                                                onPlayButton = false,
) => (dispatch, getState) => {
  const state = getState();
  const statePlayer = state.playermusica;
  const isFreePlaylist = songs[index].songSourceType === CONSTANTS.ACCESS_TYPES.FREE_PLAYLIST;

  if (isFreePlaylist && !canSkip(state, dispatch)) {
    dispatch(showNotification({show:true, title:`${Translator.get('error_music_skip_message', 'Claro música gratis permite solamente 6 skips por hora')}`, msg: null , faClass: null, type:'message'}));
    return;
  }

  let currentContent = { ...statePlayer.currentContent };
  if (replaceInsteadOfAppend) {
    currentContent = {
      ...songs[index],
      index
    };
  }

  dispatch(updateOldCurrentContet());

  dispatch({
    type: EVENTS.ADD_SONGS_TO_PLAYER_PLAYLIST_START_AT,
    index,
    songs,
    replaceInsteadOfAppend,
    atEnd,
    shuffle,
    currentContent
  });
};

export const addFavoriteSongsToPlayerPlaylistStartAt = (index,
                                                        songs,
                                                        replaceInsteadOfAppend = true,
                                                        atEnd = true,
                                                        shuffle = false,
                                                        play = false,
                                                        onPlayButton = false
) => (dispatch, getState) => {
  const state = getState();
  const statePlayer = state.player;

  let currentContent = { ...statePlayer.currentContent };
  if (replaceInsteadOfAppend) {
    currentContent = {
      ...songs[index],
      index
    };
  }

  dispatch(updateOldCurrentContet());

  dispatch({
    type: EVENTS.ADD_SONGS_TO_PLAYER_PLAYLIST_START_AT,
    index,
    songs,
    replaceInsteadOfAppend,
    atEnd,
    shuffle,
    currentContent
  });
};

export const setRadioStationDetail = (stationDetail, image = '') => (dispatch, getState) => {
  const radioImage = (image === '' ? stationDetail.image : image);

  dispatch(updateOldCurrentContet());
  const state = getState();
  if(state.playermusica.currentContent.id === stationDetail.id){
    stationDetail.isFavorite = (typeof state.playermusica.currentContent.isFavorite === 'boolean' ?
      state.playermusica.currentContent.isFavorite
      : stationDetail.isFavorite);
  }

  dispatch({
    type: EVENTS.PLAY_RADIO,
    id: stationDetail.id,
    name: stationDetail.name || stationDetail.title,
    dial: stationDetail.dial,
    band: stationDetail.band,
    image: radioImage,
    url: stationDetail.url,
    isFavorite: stationDetail.isFavorite
  });
};

export const addPlaylistSongsToPlayerPlaylist = (playlistDetail,
                                                 index = 0,
                                                 replaceInsteadOfAppend = true,
                                                 atEnd = true,
                                                 shuffle = false,
                                                 play = false,
                                                 onPlayButton = false
) => addSongsToPlayerPlaylist(playlistDetail.tracks, index, replaceInsteadOfAppend, atEnd, shuffle, play, onPlayButton);

export const addCurrentPlaylistSongsToPlayerPlaylist = (replaceInsteadOfAppend = true,
                                                        atEnd = true,
                                                        shuffle = false,
                                                        fromIndex = 0,
                                                        playlistDetails,
                                                        play = false,
                                                        onPlayButton = false,
) => (dispatch) => {
  const tracks = playlistDetails.tracks;
  dispatch(addSongsToPlayerPlaylistStartAt(fromIndex, tracks, replaceInsteadOfAppend, atEnd, shuffle, play, onPlayButton));
};

export const addCurrentArtistSongsToPlayerPlaylist = (replaceInsteadOfAppend = true,
                                                      atEnd = true,
                                                      shuffle = false,
                                                      fromIndex = 0,
                                                      tracks,
                                                      play = false,
                                                      onPlayButton = false
) => addSongsToPlayerPlaylistStartAt(fromIndex, tracks, replaceInsteadOfAppend, atEnd, shuffle, play, onPlayButton);

export const getCurrentImage = (playermusica) => {
  return playermusica && playermusica.currentContent? playermusica.currentContent.image: ''
};

export const getCurrentTitle = (playermusica) => {
  const currentContentSong =
    playermusica && playermusica.currentContent ? playermusica.currentContent.name : '';
  return currentContentSong.length > 50
    ? `${currentContentSong.substring(0, 50)}...`
    : currentContentSong;
};

export const getCurrentAlbumName = (playermusica) => {
  return playermusica && playermusica.currentContent? playermusica.currentContent.albumName: ''
};

const updateOldCurrentContet = () => (dispatch, getState) => {
  const state = getState().playermusica;
  const currentContent = state.currentContent;

  if(state.contentType === 'radio'){
    return null;
  }

  const oldCurrentContent = {
    id: currentContent.id,
    contentType: state.contentType,
    listSourceType: currentContent.listSourceType,
    songSourceType: currentContent.songSourceType,
    playlistId: currentContent.playlistId,
  };

  dispatch({
    type: EVENTS.OLD_CURRENT_TIME,
    oldCurrentContent
  });
};

export const repeatCurrentSong = () => (dispatch, getState) => {
  const currentSong = getState().playermusica.currentContent;

  dispatch(playFullMedia({
    playerstate: 'STOPPING',
    source: {
      audiosource: currentSong.url,
    },
    ispreview: false,
    islive: false,
    ispip: false,
  }));

  dispatch(playFullMedia({
    playerstate: 'PLAYING',
    source: {
      audiosource: currentSong.url,
    },
    ispreview: false,
    islive: false,
    ispip: false,
  }));

  dispatch({ type: EVENTS.REPEAT_CURRENT_SONG });
};

const playNextSongAllowingFirstSong = () => (dispatch, getState) => {
  const state = getState();
  const statePlayer = state.playermusica;
  const currentIndex = statePlayer.currentContent.index;
  const playlistLength = statePlayer.playlist.originalContent.length;

  let nextIndex;

  if (currentIndex < (playlistLength - 1)) {
    nextIndex = currentIndex + 1;
    console.log(`Will play element with index ${nextIndex}`);
  } else {
    console.log('Reached playlist lenght, will play from beggining');
    nextIndex = 0;
  }

  if ( nextIndex < 0 || nextIndex >= statePlayer.playlist.originalContent.length || nextIndex === statePlayer.currentContent.index) {
    return Promise.resolve();
  }

  const song = getSongAtIndex(statePlayer, nextIndex);

  dispatch(playFullMedia({
    playerstate: 'PLAYING',
    source: {
      audiosource: song.url,
    },
    ispreview: false,
    islive: false,
    ispip: false,
  }));

  const newCurrentContent = {
    ...song,
    index: nextIndex
  };

  dispatch({
    type: EVENTS.UPDATE_CURRENT_CONTENT,
    newCurrentContent
  });
};

export const finishPlaying = () => (dispatch, getState) => {
  const state = getState().playermusica;
  const stateUser = getState();
  const user = stateUser.user.musicUser;

  MusicUtils.setupPlay(user).then((setupPlayResponse) => { 
    console.log('Se llama setupPlay, si la respyesta es true  paso a la siguiente cancion y ya no se muestra la modal');
    return true;
  }).catch(err => {
    return false;
  });

  if (state.playlist.originalContent.length <= 1) {
    console.log('Playlist has no elements or just one element, will play same element');
    return Promise.resolve();
  }

  if (state.repeatMode === CONSTANTS.PLAYER_REPEAT_MODES.REPEAT_SINGLE) {
    return dispatch(repeatCurrentSong());
  }

  if (state.repeatMode === CONSTANTS.PLAYER_REPEAT_MODES.SIMPLE) {
    return dispatch(goToNextSong());
  }

  if (state.repeatMode === CONSTANTS.PLAYER_REPEAT_MODES.REPEAT_ALL) {
    return dispatch(playNextSongAllowingFirstSong());
  }
};

export const startPlaying = () => (dispatch, getState) => {
  const state = getState();
  const {user : {musicUser: {type = userType.ANONYMOUS} = {}} = {}} = getState();
  const statePlayer = state.playermusica;

  const isFreePlaylist = statePlayer.currentContent.songSourceType === CONSTANTS.ACCESS_TYPES.FREE_PLAYLIST;


  dispatch(checkFavoriteInsidePlayer());
  
  if (type === userType.PREMIUM) {
    return Promise.resolve();
  }

  if (isFreePlaylist) {
    dispatch({ type: EVENTS.ADD_SPOT_COUNT });
  }

  const MINUTE = 60 * 1000;
  const HOUR = 60 * MINUTE;
  const diffNow = (Date.now() - state.playermusica.firstPlay) / HOUR;

  if (!state.playermusica.firstPlay) {
    dispatch(setFirstPlay(Date.now()));
  } else if (diffNow > 1) {
    dispatch(setFirstPlay(state.player.firstPlay + HOUR));
  }
};

export const onPlayingRadio = () => (dispatch, getState) => {
  dispatch(checkFavoriteInsidePlayer());
};



// WEBPACK FOOTER //
// ./src/actions/musica/player-action-creators.js